var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortBy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0145 12.8513C18.7562 12.8513 20.1668 14.2382 20.1668 15.9493C20.1668 17.6594 18.7562 19.0463 17.0145 19.0463C15.2739 19.0463 13.8622 17.6594 13.8622 15.9493C13.8622 14.2382 15.2739 12.8513 17.0145 12.8513ZM9.24318 14.6281C10.006 14.6281 10.6253 15.2365 10.6253 15.986C10.6253 16.7345 10.006 17.3439 9.24318 17.3439H3.21562C2.45275 17.3439 1.8335 16.7345 1.8335 15.986C1.8335 15.2365 2.45275 14.6281 3.21562 14.6281H9.24318ZM4.98579 2.75C6.72745 2.75 8.13809 4.1369 8.13809 5.84701C8.13809 7.55813 6.72745 8.94503 4.98579 8.94503C3.24516 8.94503 1.8335 7.55813 1.8335 5.84701C1.8335 4.1369 3.24516 2.75 4.98579 2.75ZM18.7857 4.49013C19.5476 4.49013 20.1668 5.09853 20.1668 5.84701C20.1668 6.5965 19.5476 7.2049 18.7857 7.2049H12.7582C11.9953 7.2049 11.376 6.5965 11.376 5.84701C11.376 5.09853 11.9953 4.49013 12.7582 4.49013H18.7857Z",
    fill: "#575C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortBy);
export default __webpack_public_path__ + "static/media/sortBy.b679e3e597153a52b642c5bb9362bb8a.svg";
export { ForwardRef as ReactComponent };